import React from 'react';
import { Button } from 'common/components';
import { LoginFooterProps } from '../Login.types';
import styles from '../Login.module.scss';

const LoginFooter: React.FC<LoginFooterProps> = ({ onPrivacyClick, onTermsClick }) => {
    return (
        <div className={styles.loginFooter}>
            <p>©{new Date().getFullYear()} SLAI, Inc. All Rights Reserved.</p>
            <div className='flex gap-lg justify-center mt-sm'>
                <Button variant='linkText' size='sm' onClick={onPrivacyClick}>
                    Privacy Policy
                </Button>

                <Button variant='linkText' size='sm' onClick={onTermsClick}>
                    Terms of Service
                </Button>
            </div>
        </div>
    );
};

export default LoginFooter;
